<template>
  <artmisads-modal v-model:open="props.open" title="Upload Report" :footer="null" width="800px" @cancel="handleClose">
    <a-spin :spinning="uploading">
    <div class="upload-model">
      <div class="notice">
        <p style="margin-bottom: 4px;">Please upload the <b>Fee-Earnings CSV</b> file downloaded from Amazon Associates Central under:
          Reports → Summary.</p>
        <b>
          <Icon name="a-warring-tianchong3" style="fill: #F59B00;"/> Warning: Do not edit or modify the original file format, as this may cause upload failures.
        </b>
      </div>
      <div>
        <h4 style="font-weight: bolder;margin: 16px 0;">
          File Example:
        </h4>
        <div>
          <a-image :src="require('@/assets/images/img/uploadexample.png')" alt="file example" />
        </div>
      </div>
      <div class="file-name" v-if="fileName">
        <div>
          <svg class="icon icon-biaoge" aria-hidden="true">
            <use xlink:href="#icon-biaoge"></use>
          </svg>
          <span class="name">{{ fileName }}</span>
          <svg class="icon close-cu" aria-hidden="true" @click="clearFile">
            <use xlink:href="#icon-close-cu"></use>
          </svg>
        </div>
      </div>
      <a-upload  name="avatar" list-type="picture-card" :show-upload-list="false" accept=".csv"
        :before-upload="beforeUpload" @change="handleChange" v-else>
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <svg class="icon shangchuan2" aria-hidden="true">
          <use xlink:href="#icon-jiahao-cu"></use>
        </svg>
        Choose a file...
      </a-upload>
      <div class="upload-text">
        <img src="@/assets/images/img/pictureFrame.png" alt="pictureFrame" style="width:16px;height:16px;margin-right: 4px;"/>
        Note: For CSV files larger than  <span style="font-weight: bolder;padding-left: 4px;"> 10MB </span>, please split the data into multiple files before uploading.</div>
      <div class="footer">
        <div>
          <p>
             Before uploading the report, please ensure that all <span style="font-weight: bolder;">Associate Tags</span> 
          </p>
          <p>
            been added in ArtemisAds in advance. 
            <span style="text-decoration: underline;color: rgba(138, 100, 244, 1);cursor: pointer;" @click="goAssociateTags">EDIT NOW</span>.
          </p>
        </div>
        <artmisads-button type="primary"
         :loading="uploading"
          :disabled="!fileName"
          @click="handleUploadFile">
          Upload
        </artmisads-button>
      </div>
    </div>
    </a-spin>
  </artmisads-modal>
</template>

<script setup>
import { ref, watch } from 'vue'
import { message } from 'ant-design-vue'
import { associateCentralApi } from '~/server'
import Icon from '@/components/Icon.vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  marketplace: {
    type: String,
    default: ''
  }
})
const formData = ref(new FormData())
watch(() => props.open, (newVal) => {
  if (newVal) {
    fileName.value = ''
  }
})
const emit = defineEmits(['update:open', 'success'])
const fileName = ref('')
const fileList = ref([])
const uploading = ref(false)
const handleChange = async ({ file }) => {
  formData.value=new FormData()
  const { type, originFileObj, percent, name } = file
  if (percent === 100) {
    if (type !== 'text/csv') {
      return message.error('Please upload a csv file.')
    } else {
      fileName.value = name
      try {
        formData.value.append('file', originFileObj)
        formData.value.append('marketplace', props.marketplace)

      } catch (error) {
        message.error('Upload failed')
      }
    }
  }
}
const goAssociateTags=()=>{
   router.push('/publisher/associateCentral/associateTags')
}
const beforeUpload = (file) => {
  const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv')
  if (!isCSV) {
    message.error('You can only upload CSV file!')
    return false
  }
  const isLt10M = file.size / 1024 / 1024 < 10
  if (!isLt10M) {
    message.error('File size exceeds 10MB')
    return false
  }
  return true
}
const clearFile = () => {
  fileName.value = ''
  // props.setDataList({ successList: [], failList: [] });
}
const handleDrop = (e) => {
  e.preventDefault()
}

const handleUploadFile = async () => {
  uploading.value = true
  console.log(uploading.value,'数据上传中')
  let res =await associateCentralApi.uploadReport(formData.value)
  const { success, error, data } = res
  if (success) {
    if(data.success){
      message.success('File upload successfully. We will now begin parsing the data from the file into various reports. This process may take a few minutes.')
      emit('success')
      uploading.value = false
    }else{
      message.error("File upload failed")
      uploading.value = false
    }

  }
}

const handleClose = () => {
  emit('update:open', false)
  fileName.value = ''
}
</script>

<style lang="less" scoped>
.upload-model {
  :deep(.ant-upload-wrapper) {
    margin-top: 8px;

    .ant-upload.ant-upload-select {
      width: 100%;
      height: 64px;
      color: var(--dark-2);
      background: var(--big-bg-1);
      border: 2px dashed var(--border-1);
      border-radius: 8px;
      font-size: var(--font-size-h-l);

      &:hover {
        background: var(--bg-gray-2);
        border: 2px dashed var(--bg-gray-7);
      }

      svg {
        width: 32px;
        height: 32px;
        fill: var(--dark-2);
        margin-right: 16px;
      }
    }
  }

  :deep(.ant-upload-wrapper) {
    margin-top: 16px;

    .ant-upload.ant-upload-select {
      width: 100%;
      height: 60px;
      color: var(--dark-2);
      background: var(--big-bg-1);
      border: 1px dashed var(--border-1);
      border-radius: 8px;
      font-size: var(--font-size-h-l);
      font-weight: 500;

      &:hover {
        background: var(--bg-gray-2);
        border: 1px dashed var(--bg-gray-7);
      }

      svg {
        width: 24px;
        height: 24px;
        fill: var(--dark-2);
        margin-right: 8px;
      }
    }
  }

  .file-name {
    display: flex;
    width: 100%;
    height: 60px;
    cursor: pointer;
    background: var(--big-bg-1);
    border-radius: 8px;
    color: var(--dark-2);
    margin-top: 8px;

    &:hover {
      background: var(--bg-gray-2);
    }

    >div {
      display: flex;
      height: 28px;
      padding: 0 24px;
      border-radius: 8px;
      align-self: center;

      // &:hover {
      //   background-color: var(--bg-gray-4);
      // }
      .icon-biaoge {
        width: 24px;
        height: 24px;
        fill: var(--primary-text);
        align-self: center;
      }

      .name {
        color: var(--primary-text);
        font-weight: 500;
        font-size: 16px;
        letter-spacing: 0.4px;
        line-height: 22px;
        margin-left: 8px;
        margin-right: 24px;
        align-self: center;
      }

      .close-cu {
        cursor: pointer;
        width: 24px;
        height: 24px;
        padding: 4px;
        align-self: center;
        fill: var(--dark-3);

        &:hover {
          fill: var(--dark-1);
        }
      }
    }

  }

  .notice {
    padding: 12px;
    margin-bottom: 16px;
    background: var(--bg-gray-1);
    border-radius: 8px;

    p {
      margin: 0;
      color: var(--dark-2);
      line-height: 20px;

      span {
        color: var(--dark-1);
        font-weight: 500;
      }
    }
  }

  .upload-area {
    padding: 24px;
    background: var(--bg-gray-1);
    border-radius: 8px;
    text-align: center;

    :deep(.ant-upload-list) {
      text-align: left;
      margin-top: 16px;
    }
  }

  .upload-text {
    margin: 8px 0 0;
    color: var(--dark-2);
    font-size: 12px;
    display: flex;
    align-items: center;
   
  }

  .footer {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>